import { get,post } from "../Config";


export function GetAllPromotion({params}) {
  return get({ url: `/api/impact/v1/promotion`,params });
}

export function GetPromotionDetails({params}) {
  return get({ url: `/api/impact/v1/promotion/details`,params });
}
